<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" md="8" offset-md="2" xl="6" offset-xl="3" align="center">
        <v-card class="px-5 pb-5">
          <v-card-title class="justify-center">
            <p class="farmer_green--text headline mb-0">Congratulations!</p>
          </v-card-title>
          <v-divider class="mb-5"></v-divider>
          <p>Your account has been verified, now you can start browsing products and contacting suppliers.</p>
          <p class="welcome pt-3">Thanks for choosing us!</p>
          <v-card-actions class="justify-center">
            <v-btn outlined color="farmer_green" @click="goToPath('/')">Check out available products</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
* {
  font-family: 'Muli', sans-serif;
}
.welcome {
  font-size: 19px;
}
</style>
